export function getRandomItems(arr, count) {
	const shuffled = [...arr]; // 元配列を壊さないようコピー
	
	for (let i = shuffled.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
	}
	
	return shuffled.slice(0, count);
}
export function shuffleItems(array){
	const result = [...array];
	for (let i = result.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[result[i], result[j]] = [result[j], result[i]];
	}
	return result;
}

export function calcTime( dom, diff ){
	let m = Math.floor( diff / 60 );
	let s = diff - m*60;
	let time = `${( '00' + m ).slice( -2 )}:${( '00' + s ).slice( -2 )}`;
	dom.innerHTML = time;
}

export const usedCards = {
	STORAGE_KEY: 'usedCardIds',
	MAX_HISTORY: 24, // 何件分除外するか（全件数の半分程度が目安）

	// 使用済みIDリストを取得
	get() {
		return JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
	},

	// クリア時に使ったIDを追記
	save(usedIds) {
		let history = this.get();
		history = [...history, ...usedIds];
		// MAX_HISTORYを超えたら古いものを削除
		if (history.length > this.MAX_HISTORY) {
			history = history.slice(history.length - this.MAX_HISTORY);
		}
		localStorage.setItem(this.STORAGE_KEY, JSON.stringify(history));
	},

	// 未使用データのみ返す（足りなければ全件から抽出）
	filterUnused(allData, max) {
		const used = this.get();
		const unused = allData.filter(d => !used.includes(d.id));
		// 未使用が抽出数より少なくなったらリセットして全件対象に
		return unused.length >= max ? unused : allData;
	}
};